import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import ModalVideoPlayer from 'components/ModalVideoPlayer';
import useKalturaSession from 'hooks/useKalturaSession';
import { KALTURA_CONFIGS } from 'config/constants';
import { storesContext } from 'stores';

import '../styles.scss';

const SubscriptionsVideo = () => {
  const { userStore, classesStore } = useContext(storesContext);
  const entryId =
    userStore.enablementsConfigurations?.no_enrollment_video?.entryId;
  const uiConfId =
    userStore.enablementsConfigurations?.no_enrollment_video?.uiConfId;
  const { kalturaSession, skipKalturaSession } = useKalturaSession({
    entryId,
  });
  const isKalturaSessionResolved = kalturaSession || skipKalturaSession;

  const { hasCurrentEnrollment } = classesStore;

  if (
    !hasCurrentEnrollment &&
    isKalturaSessionResolved &&
    entryId &&
    uiConfId
  ) {
    return (
      <div className="explore-subscriptions-video">
        <ModalVideoPlayer
          entryId={entryId}
          partnerId={KALTURA_CONFIGS.partnerId}
          playerId={uiConfId}
          session={kalturaSession}
          isPlaylist
        />
      </div>
    );
  }

  return null;
};

export default observer(SubscriptionsVideo);
